var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationInvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 18.75H25.3125",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 7.5V37.5C7.5 39.5719 9.17812 41.25 11.25 41.25H33.75C35.8219 41.25 37.5 39.5719 37.5 37.5V12.8025C37.5 11.8088 37.1044 10.8544 36.4012 10.1513L31.0988 4.84875C30.3956 4.14562 29.4412 3.75 28.4475 3.75H11.25C9.17812 3.75 7.5 5.42812 7.5 7.5Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 11.25H19.6875",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6756 26.8743C22.3294 26.8743 23.4375 28.3293 23.4375 29.6849C23.4375 32.4355 18.8344 34.6874 18.75 34.6874C18.6656 34.6874 14.0625 32.4355 14.0625 29.6849C14.0625 28.3293 15.1725 26.8743 16.8244 26.8743C17.7694 26.8743 18.39 27.3168 18.75 27.7105C19.1081 27.3168 19.7306 26.8743 20.6756 26.8743Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 13.125H30C27.9281 13.125 26.25 11.4469 26.25 9.375V3.75",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationInvitation);
export default __webpack_public_path__ + "static/media/navigation-invitation.3437ca69.svg";
export { ForwardRef as ReactComponent };